import React from "react";
import { Box, Flex, HStack, Text, VStack } from "@chakra-ui/react";
import { Buildings, MapPin, Users } from "@phosphor-icons/react";
import SupplierStatusBadge from "./SupplierStatusBadge";
import ReportingYearStatus from "./ReportingYearStatus";
import SupplierActionsMenu from "./SupplierActionsMenu";

// Grid-view card for a single supplier. Clicking the card opens the supplier
// detail page; the kebab menu stops propagation so it doesn't navigate.
function SupplierCard({ supplier, onOpen, onEdit, onChangeStatus }) {
  return (
    <Box
      borderWidth="1px"
      borderColor="gray.200"
      borderRadius="lg"
      bg="white"
      boxShadow="sm"
      p={5}
      cursor="pointer"
      transition="all 0.15s"
      _hover={{ borderColor: "lime", boxShadow: "md" }}
      onClick={onOpen}
    >
      <Flex justify="space-between" align="flex-start" gap={3} mb={3}>
        <HStack spacing={2.5} align="flex-start" minW={0}>
          <Box color="limeShade.600" mt={0.5} flexShrink={0}><Buildings size={20} weight="fill" /></Box>
          <Box minW={0}>
            <Text fontSize="15px" fontWeight="700" color="darkTeal" noOfLines={1}>{supplier.name}</Text>
            <Text fontSize="12px" color="gray.500" noOfLines={1}>{supplier.category}</Text>
          </Box>
        </HStack>
        <HStack spacing={1} flexShrink={0}>
          <SupplierStatusBadge status={supplier.status} />
          <SupplierActionsMenu onEdit={onEdit} onChangeStatus={onChangeStatus} />
        </HStack>
      </Flex>

      <VStack align="stretch" spacing={1.5} mb={3}>
        {supplier.country && (
          <HStack spacing={2}><MapPin size={13} color="#A0AEC0" /><Text fontSize="13px" color="gray.600" noOfLines={1}>{supplier.country}</Text></HStack>
        )}
        <HStack spacing={2}>
          <Users size={13} color="#A0AEC0" />
          <Text fontSize="13px" color="gray.600" noOfLines={1}>
            {supplier.userCount > 0 ? `${supplier.userCount} user${supplier.userCount === 1 ? "" : "s"}` : "No users"}
          </Text>
        </HStack>
      </VStack>

      <Box pt={3} borderTop="1px solid" borderColor="gray.100">
        <Text fontSize="10px" fontWeight="600" color="gray.400" textTransform="uppercase" letterSpacing="0.04em" mb={2}>
          Outstanding tasks by year
        </Text>
        <ReportingYearStatus supplier={supplier} />
      </Box>
    </Box>
  );
}

export default SupplierCard;
